import z from 'zod';

import { ProductLine } from '../brand/brand';
import { makeEndpoint } from '../common';

export enum PointEligibleProgram {
  FIND = 'FIND',
}

export const GetPointEligibleProgramsForListingsRequestSchema = z.object({
  listings: z.array(
    z
      .object({
        id: z.string().uuid(),
        brandId: z.string().uuid().optional().nullable(),
        productLine: z.nativeEnum(ProductLine).optional().nullable(),
      })
      .passthrough(),
  ),
});

export const GetPointEligibleProgramsForListingsResponseSchema = z.record(
  z.string().uuid().nullable(),
  z
    .object({
      org: z.string(),
      payEligible: z.boolean(),
      earnEligible: z.boolean(),
    })
    .nullable(),
);

export const GetPointEligibleProgramsForListingsEndpoint = makeEndpoint({
  method: 'POST',
  url: () => `/v1/loyalty/listings/eligible`,
  responseSchema: GetPointEligibleProgramsForListingsResponseSchema,
  requestSchema: GetPointEligibleProgramsForListingsRequestSchema,
  querySchema: z.void(),
});
